import { Col, Container, Row, Card } from "react-bootstrap";
import CarouselBanner from "../../component/CarouselBanner";
import CategoryMain from "../../component/CategoryMain";
import Flashsale from "../../component/Flashsale";
import NewProduct from "../../component/NewProduct";
import { useEffect, useState } from "react";
import axios from "axios"
import moment from "moment";
import { useMyGlobal } from "../../component/GlobalData";
import { Button, Icon, Loader, Placeholder } from "semantic-ui-react";
import { DiscountedProduct } from "../../component/DiscountedProduct";
import { PlayerCategory } from "../../component/PlayerCategory";
import { Toast } from "../../component/Toast";
import { Blog } from "../../component/Blog";
import { Modal } from "react-bootstrap";
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/pagination'
import { seo_meta } from '../../component/seo';
import SeoHelmet from '../../component/SeoHelmet';

const HomePage = ({ fsData }) => {
    const [flash, setFlash] = useState([])
    const [newProduct, setNewProduct] = useState([])
    const [prdDsc, setPrdDsc] = useState([])
    const currentTime = moment().format('YYYY-MM-DD HH:mm:ss')
    const [loadNew, setLoadNew] = useState(false)
    const [noNew, setNoNew] = useState(false)
    const { token, windowWidth } = useMyGlobal()
    const [currentPage, setCurrentPage] = useState(0)
    const pagePerLoad = 12
    const [jmlProd, setJmlProd] = useState(pagePerLoad)
    const [loadMoreSpiner, setLoadMoreSpiner] = useState(false)
    const [loadMoreDisable, setLoadMoreDisable] = useState(false)
    const [labelState, setLabelState] = useState('Load More')
    const [hasMore, setHasMore] = useState(true);
    const [popupData, setPopupData] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [featData, setFeatData] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0)
    const [visited, setVisited] = useState([0])
    const [imageLoaded, setImageLoaded] = useState(false)

    useEffect(() => {
        const handleScroll = () => {
            if (
                window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 50 && !loadMoreSpiner && hasMore
            ) {
                handleClickLoadMore();
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [loadMoreSpiner, hasMore]);

    const getNewProducts = async (halaman, jumlah) => {
        setLoadMoreSpiner(true)
        setLoadMoreDisable(true)
        await axios({
            method: "GET",
            url: `${process.env.REACT_APP_ERP_URL}api_web/controler/product${global.APPSUFFIX}.php?index=21&halaman=${halaman}&jumlah=${jumlah}`,
            // url: `https://hoopsindonesia.co.id/api_hoops/controler/product.php?index=21&halaman=${halaman}&jumlah=${jumlah}`,
            headers: {
                'Content-Type': 'text/plain',
                'Authorization': token
            }
        })
            .then(res => {
                let data = []
                if (res.data.state === 200) {
                    if (res.data.data.length > 0) {
                        data = res.data.data
                        setLoadNew(true)
                        setNewProduct(prevNew => {
                            // Filter data baru yang belum ada di dalam newProduct
                            const filteredData = data.filter(item =>
                                !prevNew.some(prevItem => prevItem.id_product === item.id_product)
                            );
                            // Gabungkan data lama dengan data baru yang sudah difilter
                            return [...prevNew, ...filteredData];
                        });
                        setLoadMoreSpiner(false)
                        setLoadMoreDisable(false)
                        setHasMore(true)
                    } else {
                        setNoNew(true)
                        setHasMore(false)
                        setLoadMoreDisable(true)
                        setLoadMoreSpiner(false)
                        setLabelState(`That's the last line for new product`)
                    }

                }
            })
    }

    const handleClickLoadMore = () => {
        setCurrentPage(currentPage + pagePerLoad)
        getNewProducts(currentPage + pagePerLoad, jmlProd)
    }

    useEffect(() => {
        const getFS = async () => {
            await axios({
                method: "GET",
                url: `${process.env.REACT_APP_SRV_API_URL}controler/event.php/?index=2`,
                headers: {
                    'Content-Type': 'text/plain',
                    'Authorization': token
                }
            })
                .then(res => {
                    if (res.data.state === 200) {
                        setFlash(res.data.data)
                    }
                })
                .catch(err => {
                    if (err.response) {
                        console.log(err.response.status)
                    }
                })
        }

        const getProductDiscount = async () => {
            await axios({
                method: "GET",
                url: `${process.env.REACT_APP_ERP_URL}api_web/controler/product${global.APPSUFFIX}.php?index=19`,
                // url: `https://hoopsindonesia.co.id/api_hoops/controler/product.php?index=19`,
                headers: {
                    'Content-Type': 'text/plain',
                    'Authorization': token
                }
            })
                .then(res => {
                    if (res.data.state === 200) {
                        setPrdDsc(res.data.data)
                    }
                })
        }
        getFS()
        getNewProducts(currentPage, jmlProd)
        //document.title = "Hoops Indonesia | Home"
        // getProductDiscount()
    }, [token])

    const seoMeta = seo_meta.home
 useEffect(() => {
        const getPopups = async () => {
            try {
                const res = await axios({
                    method: "GET",
                    url: `${process.env.REACT_APP_SRV_API_URL}controler/popup.php?index=1`,
                    headers: {
                        'Content-Type': 'text/plain',
                        'Authorization': token
                    }
                });

                const list = res?.data?.data;

                // guard
                if (!Array.isArray(list) || list.length === 0) {
                    return;
                }

                const data = list[0];

                // guard
                if (!data || data.is_active !== "Y") {
                    return;
                }
                
                if (data.is_active === "Y") { setPopupData(data); 
                // optional delay biar gak ngeselin 
                setTimeout(() => { setShowPopup(true); }, 1000); } 

                const isShown = localStorage.getItem("popup_shown"); 
                if (!isShown && data.is_active === "Y") { 
                    setPopupData(data); 
                    setShowPopup(true); 
                    localStorage.setItem("popup_shown", "true"); 
                } 

            } catch (err) {
                console.log(err);
            }
        };

        getPopups();
    }, [token]);

    useEffect(() => {
        const getFeatured = async () => {
            try {
                const res = await axios({
                    method: "GET",
                    url: `${process.env.REACT_APP_SRV_API_URL}controler/featured.php?index=1`,
                    headers: {
                        'Content-Type': 'text/plain',
                        'Authorization': token
                    }
                });

                const list = res?.data?.data;

                // guard
                if (!Array.isArray(list) || list.length === 0) {
                    setFeatData([]);
                    return;
                }

                // check active
                const isActive = list[0]?.is_active === "Y";

                if (!isActive) {
                    setFeatData([]);
                    return;
                }

                // Sort
                const order = { left: 0, center: 1, right: 2 };

                const sorted = [...list].sort((a, b) => {
                    return order[a.position] - order[b.position];
                });

                setFeatData(sorted);

            } catch (err) {
                console.log(err);
            }
        };

        getFeatured();
    }, [token]);

    
    const orderedFeat = featData;

/*
    useEffect(() => {
        const getPopup = async () => {
            try {
                const res = await axios({
                    method: "GET",
                    //url: `${process.env.REACT_APP_SRV_API_URL}controler/popup.php`,
                    url: `https://dev.javafootwear.com/api_hoops/controler/popup.php`,
                    headers: {
                        'Content-Type': 'text/plain',
                        'Authorization': token
                    }
                });

                if (res.data) {
                    const data = res.data;
                    console.log(data)

                    if (data.is_active === "Y") {
                        setPopupData(data);

                        // optional delay biar gak ngeselin
                        setTimeout(() => {
                            setShowPopup(true);
                        }, 1000);
                    }

                    const isShown = localStorage.getItem("popup_shown");

                    if (!isShown && data.is_active === "Y") {
                        setPopupData(data);
                        setShowPopup(true);
                        localStorage.setItem("popup_shown", "true");
                    }
                }
            } catch (err) {
                console.log(err);
            }
        };

        getPopup();
    }, [token]);
*/

    const handlePopupAction = () => {
        if (popupData?.url != "" && popupData?.url) {
            //window.location.href = popupData.url;
            window.open(popupData.url, "_blank");
        } else {
            setShowPopup(false);
        }
    };


    useEffect(() => {
        setImageLoaded(false)
    }, [popupData])

    return (
        <>

        <SeoHelmet
            title={seoMeta.title}
            description={seoMeta.description}
        />

        {/*
        {popupData && (
            <Modal
                show={showPopup}
                onHide={() => setShowPopup(false)}
                centered
                contentClassName="popup-custom"
            >
                <div className="popup-image-wrapper">
                    
                    <div className="popup-close" onClick={() => setShowPopup(false)}>
                        ?
                    </div>

                    <img
                        src={popupData.image}
                        loading="eager" // pastiin gak di-lazy
                        alt="popup"
                        className="popup-image"
                        onClick={popupData.url != "" ? handlePopupAction : null}
                        style={{ cursor: popupData?.url && popupData?.url != "" ? "pointer" : "default" }}
                        fetchPriority="high"
                    />

                    <div className="popup-overlay"
                        onClick={popupData?.url && popupData?.url != "" ? handlePopupAction : null} />

                    <div className="popup-content">
                        <Button
                            className="popup-btn"
                            onClick={handlePopupAction}
                        >
                            {popupData?.url && popupData?.url != "" ? "Check Now !" : "Close"}
                        </Button>

                        {popupData?.information && popupData?.information != "" && (
                            <p className="popup-desc">{popupData.information}</p>
                        )}
                    </div>

                </div>
            </Modal>
        )}
        */}

        {popupData && (
            <Modal
                show={showPopup}
                onHide={() => setShowPopup(false)}
                centered
                contentClassName="popup-custom"
            >
                <div className="popup-image-wrapper">

                    {/* IMAGE */}
                    <img
                        src={popupData.image}
                        loading="eager"
                        fetchPriority="high"
                        alt="popup"
                        className="popup-image"
                        onLoad={() => setImageLoaded(true)}
                        onClick={
                            popupData.url != ""
                                ? handlePopupAction
                                : null
                        }
                        style={{
                            cursor:
                                popupData?.url && popupData?.url != ""
                                    ? "pointer"
                                    : "default",

                            visibility: imageLoaded
                                ? "visible"
                                : "hidden"
                        }}
                    />

                    {/* tampil setelah image ready */}
                    {imageLoaded && (
                        <>
                            <div
                                className="popup-close"
                                onClick={() => setShowPopup(false)}
                            >
                                ?
                            </div>

                            <div
                                className="popup-overlay"
                                onClick={
                                    popupData?.url && popupData?.url != ""
                                        ? handlePopupAction
                                        : null
                                }
                            />

                            <div className="popup-content">
                                <Button
                                    className="popup-btn"
                                    onClick={handlePopupAction}
                                >
                                    {popupData?.url && popupData?.url != ""
                                        ? "Check Now !"
                                        : "Close"}
                                </Button>

                                {popupData?.information &&
                                    popupData?.information != "" && (
                                        <p className="popup-desc">
                                            {popupData.information}
                                        </p>
                                )}
                            </div>
                        </>
                    )}

                </div>
            </Modal>
        )}
        
        <section className="page-margin-top" style={{ height: '100%' , backgroundColor: '#f5f5f5'}}>            <CarouselBanner />
            <Container>
                {/* {
                    <Row>
                        <Col md={12}>
                            <DiscountedProduct data={prdDsc} />
                        </Col>
                    </Row>
                } */}
                {
                    <Row className="mb-5">
                        <Col>
                            <PlayerCategory />
                        </Col>
                    </Row>
                }
            </Container>

            

{windowWidth < 768 ? (
    // MOBILE ? SWIPER
    <div className="feat-wrapper mb-5">
        <div className="ig-progress">
            {orderedFeat.map((_, i) => (
                <div
                    key={i}
                    className={`ig-bar ${
                        visited.includes(i) ? 'active' : ''
                    }`}
                />
            ))}
        </div>

        <Swiper
            slidesPerView={1}
            spaceBetween={0}
            grabCursor={true}
            loop={true}
            observer={true}
            observeParents={true}
            onRealIndexChange={(swiper) => {
                const current = swiper.realIndex

                setVisited((prev) => {
                    // kalau pindah ke index 0 ? reset
                    if (current === 0) {
                        return [0]
                    }

                    // kalau belum pernah ? tambahin
                    if (!prev.includes(current)) {
                        return [...prev, current]
                    }

                    return prev
                })

                setActiveIndex(current)
            }}
        >
            {orderedFeat.map((item, i) => (
                <SwiperSlide key={item.position}>
                    <div className="feat-col">
                        {item.is_video === "Y" && item.video ? (
                            <video
                                autoPlay
                                muted
                                loop
                                playsInline
                                preload="metadata"
                                className="feat-media"
                            >
                                <source src={item.video} type="video/mp4" />
                            </video>
                        ) : item.image ? (
                            <img src={item.image} alt="img" className="feat-media" />
                        ) : null}
                        <div className="feat-overlay" />
                        {(item.url || item.information) && (
                            <>
                            <div className="feat-content">
                                <div className="feat-inner">
                                    {item.url && (
                                        <a href={item.url}>
                                            <button className="ui button feat-btn w-[50%]">Check Now !</button>
                                        </a>
                                    )}
                                    {item.information != "" && (
                                    <p className="feat-desc">{item.information}</p>
                                    )}
                                </div>
                            </div>
                            </>
                        )}
                    </div>
                </SwiperSlide>
            ))}
        </Swiper>
    </div>
) : (
    // ? DESKTOP ? GRID
    <div className="row-feat-col mb-5">
        {orderedFeat.map((item, i) => (
            <div className="feat-col" key={item.position}>
                {item.is_video === "Y" && item.video ? (
                    <video
                        autoPlay
                        muted
                        loop
                        playsInline
                        preload="metadata"
                        className="feat-media"
                    >
                        <source src={item.video} type="video/mp4" />
                    </video>
                ) : item.image ? (
                    <img src={item.image} alt="img" className="feat-media" />
                ) : null}
                <div className="feat-overlay" />
                {(item.url || item.information) && (
                    <>
                        <div className="feat-content">
                            {item.url && (
                                <a href={item.url}>
                                    <button className="ui button feat-btn">Check Now !</button>
                                </a>
                            )}
                            {item.information !== "" && (
                                <p className="feat-desc">{item.information}</p>
                            )}
                        </div>
                    </>
                )}
            </div>
        ))}
    </div>
)}



            <Container>
                {/* {
                    <Row className="mb-5">
                        <Col>
                            <CategoryMain />
                        </Col>
                    </Row>
                    }
                */}
                {
                    flash.length > 0 &&
                        currentTime >= flash[0].date_start && currentTime <= flash[0].date_end ?
                        <Row className="mb-5">
                            <Col md={12}>
                                <Flashsale dataFs={flash} />
                            </Col>
                        </Row>
                        :
                        <></>
                }
                {/* {
                    <Row className="mb-5">
                        <Col>
                            <Blog />
                        </Col>
                    </Row>
                } */}
                {   loadNew ?
                    <Row style={{ height: '100%' , backgroundColor: '#f5f5f5'}}>
                        <Col md={12}>
                            <NewProduct data={newProduct} />
                        </Col>
                        <Col md={12} className="d-flex justify-content-center">
                            {/* <Button
                                fluid = {windowWidth <= 600 ? true : false}
                                content={labelState}
                                onClick={() => handleClickLoadMore()}
                                loading={loadMoreSpiner}
                                basic
                                color="orange"
                                disabled={loadMoreDisable}
                                icon={labelState == 'Load More' ? 'redo alternate' : 'ban'}
                            /> */}
                            {
                                hasMore ?
                                    <div className="pb-2" style={{ height: "20px", textAlign: "center" }}>
                                        {
                                            loadMoreSpiner ?
                                                <Loader active inline size="small" />
                                                :
                                                <Icon name="angle double down" size="big" className="bounce" />
                                        }
                                    </div>
                                    :
                                    <div style={{ height: "20px", textAlign: "center" }}>
                                        <p>All product has been loaded</p>
                                    </div>
                            }
                        </Col>
                    </Row>
                    : noNew ?
                    <></>
                    :
                    <Row style={{ height: '100%' , backgroundColor: '#f5f5f5'}}>
                        {   [...Array(4)].map((_, i) => (
                            <Col xl={3} lg={3} md={3} sm={6} xs={6} key={i}>
                                {/* kita mimic ProductCard structure */}
                                <div className="mt-3 mb-3">
                                    <Card className="product-card">
                                        
                                        {/* IMAGE CAROUSEL AREA */}
                                        <div style={{ aspectRatio: '9 / 11' }}>
                                        <Placeholder fluid style={{ width: '100%', height: '100%' }}>
                                            <Placeholder.Image rectangular style={{ width: '100%', height: '100%' }} />
                                        </Placeholder>
                                        </div>

                                    </Card>
                                </div>
                            </Col>
                        ))
                        }
                    </Row>
                }
            </Container>
        </section>
        </>
    )
}

export default HomePage;